export const createEmptyData = (headers: string[]) => {
  return headers.reduce(
    (acc, header) => {
      return {
        ...acc,
        [header]: "",
      };
    },
    {} as Record<string, string>,
  );
};
